(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const skValue = urlParams.get('sk');

  const attributes = ['sk', 'utm_campaign', 'utm_source', 'utm_content', 'utm_medium', 'publisher', 'campaign_name', 'gclid', 'fbclid'];
  const attributeValues = {}

  for (const key of attributes) {
    const val = urlParams.get(key)

    if (val) {
      attributeValues[key] = val   

      if (typeof localStorage !== "undefined") {
        localStorage.setItem(key, val);    
      }
    }
  }

  if (Object.keys(attributeValues).length > 0) {
    const formData = new FormData()

    for (const key in attributeValues) {
      const val = attributeValues[key]
      formData.append("attributes[_"+key + "]", val);  
    }
    
    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        
      });
  }
})();

